module.exports = __webpack_public_path__ + "glyphicons-halflings-regular.fa2772327f55d8198301.woff";


//////////////////
// WEBPACK FOOTER
// C:/Users/oggy.yuristantyo/source/Workspaces/UI_SBN_Ritel_Web/src/fonts/glyphicons-halflings-regular.woff
// module id = ../../../../../src/fonts/glyphicons-halflings-regular.woff
// module chunks = 2